  <td class="no-padding">
    <p class=" pt-0 py-1 m-0" *ngIf="!summaryOption.isFabric"
       [ngStyle]="{'text-indent.px': (summaryOption.indent >0 ?summaryOption.indent * 10:'') }"
    >{{ summaryOption.name + ':'}}&nbsp;<ng-container *ngFor="let summarySubOption of summaryOption.summarySubOptions"><span>{{summarySubOption}}</span></ng-container></p>
    <p class="pt-0 py-1 m-0" *ngIf="summaryOption.isFabric" [ngStyle]="{'text-indent.px': (summaryOption.indent >0 ?summaryOption.indent * 10:'') }">{{summaryOption.fabricCollection ? ('doctrine.fabric.fabric'|translate) + ': ' + summaryOption.fabricCollection : ''}}{{summaryOption.fabric ? ', ' + summaryOption.fabric : ''}}{{summaryOption.fabricColor ? ', ' + summaryOption.fabricColor : ''}}</p>
  </td>
  <td class="no-padding">
  <p class="pt-0 py-1 m-0" *ngIf="!summaryOption.isFabric">{{summaryOption.amount}}</p>
  </td>
  <td class="no-padding">
    <p class="pt-0 py-1 m-0" *ngIf="!summaryOption.isFabric && showPrice">
    {{(customerPrice ? summaryOption.customerPrice : summaryOption.dealerPrice) | CustomCurrency}}
    </p>
  </td>
  <td class="no-padding">
    <p class="pt-0 py-1 m-0" *ngIf="!summaryOption.isFabric && showPrice">
      {{(customerPrice ? summaryOption.cost.customerPrice : summaryOption.cost.dealerPrice) | CustomCurrency}}
    </p>
  </td>

